import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MaterialUiInput from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

class Input extends Component {
  render() {
    const {
      placeholder = '',
      type = 'text',
      value,
      onChange = () => {},
      disabled,
      classes,
      error = ''
    } = this.props

    return (
      <FormControl className={classes.container}>
        <InputLabel
          FormLabelClasses={{
            root: classes.cssLabel,
            focused: classes.cssFocused
          }}
        >
          {placeholder}
        </InputLabel>
        <MaterialUiInput
          classes={{
            underline: classes.cssUnderline
          }}
          type={type}
          value={value}
          onChange={event => onChange(event.target.value)}
          disabled={disabled}
          error={error !== ''}
        />
        <FormHelperText id={'name-error-text'}>{error}</FormHelperText>
      </FormControl>
    )
  }
}

const Styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#289e64'
    }
  }
}

export default withStyles(Styles)(Input)



// WEBPACK FOOTER //
// ./src/components/common/Input.js